import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();

  const quickLinks = [
    { to: '/', label: t('nav.home') },
    { to: '/category/all', label: t('nav.category') },
    { to: '/about', label: t('nav.about') },
  ];

  const serviceLinks = [
    { to: '/about', label: t('footer.help') },
    { to: '/about', label: t('footer.feedback') },
    { to: '/about', label: t('footer.contact') },
  ];

  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="flex items-center gap-2.5 mb-4">
              <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500 text-background-50 font-bold text-lg">
                <i className="ri-play-circle-fill text-xl"></i>
              </div>
              <div>
                <span className="font-semibold text-base text-foreground-950">{t('site.name')}</span>
                <span className="block text-xs text-foreground-600">{t('site.slogan')}</span>
              </div>
            </Link>
            <p className="text-sm text-foreground-600 leading-relaxed">{t('site.description')}</p>
          </div>

          <div>
            <h4 className="font-semibold text-foreground-950 mb-4">{t('footer.quickLinks')}</h4>
            <ul className="space-y-2.5">
              {quickLinks.map((link) => (
                <li key={link.to}>
                  <Link to={link.to} className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-foreground-950 mb-4">{t('footer.customerService')}</h4>
            <ul className="space-y-2.5">
              {serviceLinks.map((link) => (
                <li key={link.to}>
                  <Link to={link.to} className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-foreground-950 mb-4">{t('footer.follow')}</h4>
            <div className="flex gap-3 mb-4">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-200/70 text-foreground-600 hover:bg-primary-500 hover:text-background-50 transition-all" aria-label="微信" rel="nofollow">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-200/70 text-foreground-600 hover:bg-primary-500 hover:text-background-50 transition-all" aria-label="微博" rel="nofollow">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-200/70 text-foreground-600 hover:bg-primary-500 hover:text-background-50 transition-all" aria-label="抖音" rel="nofollow">
                <i className="ri-tiktok-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-200/70 text-foreground-600 hover:bg-primary-500 hover:text-background-50 transition-all" aria-label="B站" rel="nofollow">
                <i className="ri-bilibili-line"></i>
              </a>
            </div>
            <p className="text-xs text-foreground-500">客服热线：400-888-8888</p>
            <p className="text-xs text-foreground-500">service@aiyivideo.com</p>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">{t('footer.rights')}</p>
          <div className="flex items-center gap-4">
            <Link to="/about" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors">{t('footer.privacy')}</Link>
            <Link to="/about" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors">{t('footer.terms')}</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}